<template>
    <div>
        <my-form
        class="form-page"
        v-model="form"
        table
        readonly
        label-width="160px"
        @cancle="cancleHandler">

            <el-form-item
            label="标段名称">
                {{form.bdnames}}
            </el-form-item>

            <el-form-item
            label="评审开始时间">
                {{form.pstime}}
            </el-form-item>
 
            <el-form-item
            label="专家数量">
                {{form.shuliang}}
            </el-form-item>

            <el-form-item
            label="是否统一专家库抽取" v-if="isnzk===false">
                {{form.typbzjk === '1' ? '是' : '否'}}
            </el-form-item>
                                   
            <el-form-item
            label="专家库" v-if="isnzk===true">
                <span v-if="form.typbzjk==='1'"> 
                    河北省统一专家库
                </span>
                <span v-if="form.typbzjk==='2'"> 
                    {{form.dwcnname}}专家库
                </span>
                <span v-if="form.typbzjk==='0'"> 
                    自行组建
                </span>
            </el-form-item>
            <el-form-item
            label="评标室">
                {{form.bidevaluation_room}}
            </el-form-item>

        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

export default {
    mixins: [ FORM_PAGE_MIXIN ],
    components: { },
    data: () => ({
        form: {},
        isnzk:''
    }),
    methods: {

    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/detail.json`, 
        {
            id: this.getQuery('id'),
            procode:this.getQuery('procode'),
            zgys:this.getQuery('zgys'),
        }
        , data => {
            var model = data.model;
            model.jyzx = data.jyzx;
            model.shuliang = data.sum;
            this.form = model;
            this.isnzk=data.isnzk;
            this.jspDataInit(data, []);
        });
    }
}
</script>

<style scoped lang="scss">

</style>
